import { tradegwApi } from '../request'
import { apiPath } from '../api'

export const tpPay = {
  queryBillDetail: data => tradegwApi.post(apiPath.queryBillDetail, data),
  queryDetailsByGroupDeliveryDate: data =>
    tradegwApi.post(apiPath.queryDetailsByGroupDeliveryDate, data),
  queryBillRange: data => tradegwApi.post(apiPath.queryBillRange, data),
  exportBillDetail: data => tradegwApi.post(apiPath.exportBillDetail, data),
  getBillAnalysis: data => tradegwApi.post(apiPath.getBillAnalysis, data),
  downloadFile: data => tradegwApi.post(apiPath.downloadFile, data),
  getBillTip: data => tradegwApi.post(apiPath.getBillTip, data),
  exportList: data => tradegwApi.post(apiPath.exportList, data),
  exportDetails: data => tradegwApi.post(apiPath.exportDetails, data),
  getBillCompanyList: data => tradegwApi.post(apiPath.getBillCompanyList, data)
}
